var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"head"},[_c('div',{staticClass:"main-bar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-5"},[_c('h4',{staticClass:"nav_top_align text-dark"},[_c('i',{staticClass:"fa fa-book",attrs:{"aria-hidden":"true"}}),_vm._v(" ข้อสอบทั้งหมด ")])])])])])
}]

export { render, staticRenderFns }